import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';

const CalculationCreateNew = React.lazy(() => import('../components/CalculationCreate'));
function CalculationCreateView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <CalculationCreateNew {...props} />
    </Suspense>
  );
}

export default CalculationCreateView;
